// extracted by mini-css-extract-plugin
export var primitiveLabel = "_t5-0";